import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import { type LogoutPageProps } from './codegen/LogoutPageProps';
import LogoutPage from './pages/logout/LogoutPage';
import { type FlowProps, combineProps } from './FlowProps';

export type LogoutProps = FlowProps<LogoutPageProps>;

export const LogoutFlow = (args: LogoutProps) => {
    const location = useLocation();

    return (
        <Routes>
            <Route
                index
                element={
                    <LogoutPage
                        {...combineProps(
                            location.state,
                            args as FlowProps<LogoutPageProps>,
                        )}
                    />
                }
            />
        </Routes>
    );
};
